import { useEffect, useState } from 'react';
import { PriorityProject } from './model';
import useUserData from 'hooks/useUserData';

const usePriorityProjectsStore = () => {
  const [priorityProjects, setPriorityProjects] = useState<PriorityProject[]>([]);
  const [pending, setPending] = useState(false);
  const [isInformModalOpen, setIsInformModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState<PriorityProject | null>(null);

  const userData = useUserData();
  const userId = userData?.id;

  const fetchPriorityProjects = async () => {
    setPending(true);

    if(!userId) return

    try {
      const response = await fetch(
        'https://uchi.ru/api/configurator/public?configs=cabmun_region_priority_projects_list',
      ).then((res) => res.json());

      const projects: PriorityProject[] = response?.cabmun_region_priority_projects_list;

      const filteredProjectsCurrRegion = projects.filter((project) => {
        const municipalityIds = project.ids_municipality.split(',').map((id) => id.trim());
        return municipalityIds.includes(userId.toString());
      });

      setPriorityProjects(filteredProjectsCurrRegion);
    } catch (error) {
      console.error(error);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    fetchPriorityProjects();
  }, []);

  return {
    priorityProjects,
    pending,
    isInformModalOpen,
    setIsInformModalOpen,
    selectedProject,
    setSelectedProject,
  };
};

export default usePriorityProjectsStore;
